module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('station-activity-dashboard', {
    attrs: {
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "stationActivityData": _vm.stationActivityData,
      "isLoading": _vm.loadingStationActivity
    },
    on: {
      "changeRegion": _vm.handleChangeRegion,
      "changeDate": _vm.handleChangeDate,
      "changePage": _vm.handleChangePage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f838538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/admin/StationActivityContainer.vue
// module id = 3367
// module chunks = 3